import { jsx as _jsx } from "react/jsx-runtime";
export function Button({ variant = "primary", size = "md", iconOnly = false, className = "", type = "button", children, ...rest }) {
    const sizeClass = size === "md" ? "" : ` nbs-button--${size}`;
    const iconOnlyClass = iconOnly ? " nbs-button--icon-only" : "";
    return (_jsx("button", { type: type, className: `nbs-button nbs-button--${variant}${sizeClass}${iconOnlyClass} ${className}`.trim(), ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map